import { Button, Card, Col, Form, Table } from "react-bootstrap";
import { JConfirmDelete, JRow, MensagemModal } from "../../../components/Components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { infUnidCargaVaziaInteface, SelectObjectRemoveInterface } from "../../../interfaces";
import { useRef, useState } from "react";
import { getUuidV4, goToFocus } from "../../../utils/utils";
import { addUnidadeCargaVazia, removeUnidadeCargaVazia } from "../../../features/manifestoSlice";
import { Link } from "react-router-dom";
import { TypeUnidadesCargaVazia } from "../../../lists";



const initialState: infUnidCargaVaziaInteface = {
    id: 0,
    idunidcargavazia: '',
    tpunidcargavazia: '1'
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function UnidadeCargaVazia() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.modal_aquatico.infUnidCargaVazia);
    const [form, setForm] = useState<infUnidCargaVaziaInteface>(initialState);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const idUnidadeRef = useRef<HTMLInputElement>(null)

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validaPreenchimento = () => {
        if (form.idunidcargavazia.toString() === "") {
            alerta('Informe a Identificação');
            goToFocus(idUnidadeRef);
            return false;
        }

        if (lista.find((item: infUnidCargaVaziaInteface) =>
            item.idunidcargavazia.trim() === form.idunidcargavazia.trim() &&
            item.tpunidcargavazia === form.tpunidcargavazia)) {
            alerta('Identificação já adicionado para o tipo de unidade informado.');
            return false;
        }

        return true;
    }

    const handleAdd = () => {
        if (validaPreenchimento()) {
            dispatch(addUnidadeCargaVazia({ ...form, id: getUuidV4() }))
            setForm(initialState);
            goToFocus(idUnidadeRef);
        }
    }

    const handleRemover = (id: number) => {
        dispatch(removeUnidadeCargaVazia(id));
        setShowModal(false);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return (<>
        <Card className="card-primary card-outline">
            <Card.Header>Informações das unidades de carga vazia <span
                className="text-primary fw-semibold">(Opcional)</span>
            </Card.Header>
            <Card.Body>
                <JRow className="mb-3">
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>* Identificação</Form.Label>
                            <Form.Control type="text" name="idunidcargavazia" maxLength={20} ref={idUnidadeRef}
                                value={form.idunidcargavazia}
                                onChange={handleChange} />
                        </Form.Group>
                    </Col>

                    <Col md>
                        <Form.Group>
                            <Form.Label>* Tipo Unidade</Form.Label>
                            <Form.Select name="tpunidcargavazia" onChange={handleChange}
                                value={form.tpunidcargavazia}
                            >
                                {TypeUnidadesCargaVazia.map(x => (
                                    <option key={x.id} value={x.id}>{x.name}</option>
                                ))}

                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={'auto'} className="d-flex  align-items-end">
                        <Button variant="primary" onClick={handleAdd}>
                            <FontAwesomeIcon icon={faPlus} />  Adicionar
                        </Button>
                    </Col>
                </JRow>

                <Table striped bordered hover size="sm" responsive>
                    <thead className="table-light">
                        <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Identificação</th>
                            <th className="text-center" >Tipo Unidade</th>
                        </tr>
                    </thead>

                    <tbody>
                        {lista?.map((item: infUnidCargaVaziaInteface) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <Link to={''} className="text-danger"
                                        onClick={() => handleOpenModal({ id: item.id, title: item.idunidcargavazia })}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Link>
                                </td>
                                <td className="text-center">{item.idunidcargavazia}</td>
                                <td className="text-center">{TypeUnidadesCargaVazia.find(t =>
                                    t.id === item.tpunidcargavazia.toString().trim())?.name}
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </Table>

            </Card.Body>
        </Card>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemover}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}